function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#418fde",
    d: "M46.4 24.35C46.39 24.34 28 14 28 14V4a4 4 0 0 0-8 0v10L1.28 24.57A2.948 2.948 0 0 0 0 27a2.996 2.996 0 0 0 3 3 2.813 2.813 0 0 0 .92-.15L20 25v15l-6.06 4.31a1.857 1.857 0 0 0-.45.39A1.938 1.938 0 0 0 13 46a2.006 2.006 0 0 0 2 2 1.49 1.49 0 0 0 .3-.03l8.7-2.86 8.28 2.75A1.917 1.917 0 0 0 33 48a2.006 2.006 0 0 0 2-2 1.957 1.957 0 0 0-.41-1.2 1.778 1.778 0 0 0-.53-.49L28 40V25l15.97 4.81A2.94 2.94 0 0 0 45 30a2.998 2.998 0 0 0 1.4-5.65z",
    "data-name": "Layer 2",
    style: {
      fill: "#000000"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.2429290a8a11942a2dde8355744624c4.svg";
export { ForwardRef as ReactComponent };